import { Clock, MapPin, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { TOURS, TID } from "@/data/site";

const TourCard = ({ tour }) => {
  return (
    <article
      data-testid={TID.tourCard(tour.id)}
      className="group rounded-3xl overflow-hidden glass lift flex flex-col"
    >
      <div className="relative aspect-[5/4] overflow-hidden">
        <img
          src={tour.image}
          alt={tour.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1830]/95 via-[#0a1830]/20 to-transparent" />
        <div className="absolute bottom-4 left-5 right-5 flex items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-3 text-[0.72rem] uppercase tracking-[0.18em] text-foreground/75">
              <Clock className="h-3.5 w-3.5" /> {tour.duration}
            </div>
            <h3 className="mt-1 font-display text-2xl leading-tight">
              {tour.title}
            </h3>
          </div>
          <div className="font-display text-xl text-gold whitespace-nowrap">
            {tour.price}
          </div>
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col">
        <p className="text-sm text-foreground/75 leading-relaxed">{tour.blurb}</p>

        {tour.stops && (
          <div className="mt-5 pt-5 border-t border-white/8">
            <div className="text-[0.7rem] uppercase tracking-[0.2em] text-gold mb-3">
              Tour stops
            </div>
            <ol className="space-y-2.5">
              {tour.stops.map((stop, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm text-foreground/85"
                >
                  <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold text-[0.7rem] font-semibold">
                    {i + 1}
                  </span>
                  <span>{stop}</span>
                </li>
              ))}
            </ol>
          </div>
        )}

        <Link
          to="/checkout"
          onClick={() => {
            sessionStorage.setItem("pendingService", tour.id);
          }}
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-white/5 border border-white/10 text-foreground hover:bg-gold hover:text-[#0a1830] hover:border-gold px-5 py-3 text-sm font-semibold transition-all"
          data-testid={`tour-cta-${tour.id}`}
        >
          Book this tour
        </Link>
      </div>
    </article>
  );
};

const Tours = () => {
  return (
    <section
      id="tours"
      data-testid={TID.toursSection}
      className="section relative bg-aegean grain"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-3xl">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Private taxi tours
            <br />
            <span className="text-gold italic">in your own pace.</span>
          </h2>
          <p className="mt-6 text-foreground/75 max-w-xl leading-relaxed">
            Explore Greece in comfort with your own English-speaking driver and
            a private taxi.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TOURS.map((t) => (
            <TourCard key={t.id} tour={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tours;
